// extracted by mini-css-extract-plugin
export default {"title":"c3595930c7","inner_title":"_17b04c2248","charge_btn":"_1cfffa5c04"};